module.exports = __webpack_public_path__ + "img/absorbente5.91b7011c.jpg";